module.exports = __webpack_public_path__ + "static/media/coffee-cup-transparent.bbc16b73.png";